import { getUserId } from 'utils/user';
import { useUser } from './useUser';

export function useUserId(): string | undefined {
  const user = useUser();

  return getUserId(user);
}
